import { TableExpanded as BaseTable } from "@/components/Table";
import { HeaderDef } from "@/types/table";
import { getColumns } from "@/utils/table";
import type {
  PortableTextTypeComponent,
  PortableTextTypeComponentProps,
} from "@portabletext/react";
import styles from "./Table.module.scss";

export type TableValue<TData> = {
  tableData: string;
  headers: HeaderDef<TData>[];
};

export type TableProps<TData> = PortableTextTypeComponentProps<
  TableValue<TData>
>;

const Table: PortableTextTypeComponent = <TData extends object>({
  value,
}: TableProps<TData>) => {
  const { tableData, headers } = value;
  const parsed = JSON.parse(tableData || "[]");
  const columns = getColumns(headers);

  return (
    <div className={styles.centered}>
      <BaseTable data={parsed} columns={columns} />
    </div>
  );
};

export default Table;
